"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("./types");
exports.ConfirmActions = {
    confirm: function (payload) {
        return {
            type: types_1.ConfirmActionTypes.SHOW,
            payload: payload
        };
    },
    hide: function () {
        return {
            type: types_1.ConfirmActionTypes.HIDE
        };
    },
    destroy: function () {
        return {
            type: types_1.ConfirmActionTypes.DESTROY
        };
    }
};
